// extracted by mini-css-extract-plugin
module.exports = {"collection-meta":"_2f-NF","collection-summary":"_3IGFw"};